import { defineMessages } from 'react-intl';

export const scope = 'axionoee.features.calendar';

export default defineMessages({
    planningPerMonthTab: {
        id: `${scope}.label.planningPerMonthTab`,
        defaultMessage: 'Planning per month',
    },
    weekTemplatesTab: {
        id: `${scope}.label.weekTemplatesTab`,
        defaultMessage: 'Week templates',
    },
    planTab: {
        id: `${scope}.label.planTab`,
        defaultMessage: 'Plan',
    },
    machinePlanTab: {
        id: `${scope}.label.machinePlanTab`,
        defaultMessage: 'Available hours per machine and day',
    },
    exceptionsTab: {
        id: `${scope}.label.exceptionsTab`,
        defaultMessage: 'Exceptions',
    },
    scheduleOverview: {
        id: `${scope}.label.scheduleOverview`,
        defaultMessage: 'Schedule overview (for machines and days)',
    },
    month: {
        id: `${scope}.label.month`,
        defaultMessage: 'Month',
    },
    machine: {
        id: `${scope}.label.machine`,
        defaultMessage: 'Machine',
    },
    overriddenHours: {
        id: `${scope}.label.overriddenHours`,
        defaultMessage: 'Overridden',
    },
    hours: {
        id: `${scope}.label.hours`,
        defaultMessage: 'hours',
    },
    changeOrOverrideTemplatee: {
        id: `${scope}.label.changeTemplateOrOverride`,
        defaultMessage: 'Change template or override planned hours',
    },
    overrideTemplateForDay: {
        id: `${scope}.label.overrideTemplateForDay`,
        defaultMessage: 'Override template for day',
    },
    nrOfHours: {    
        id: `${scope}.label.nrOfHours`,
        defaultMessage: 'Nr of hours',
    },
    cancel: {
        id: `${scope}.label.cancel`,
        defaultMessage: 'Cancel',
    },
    removeTempalteForDay: {
        id: `${scope}.label.removeTemplateForDay`,
        defaultMessage: 'Remove template for day',
    },
    weekTemplates: {
        id: `${scope}.label.weekTemplates`,
        defaultMessage: 'Week Templates',
    },
    addWeekTemplate: {
        id: `${scope}.label.addWeekTemplate`,
        defaultMessage: 'Add Week Template',
    },
    selectWeekTemplate: {
        id: `${scope}.label.selectWeekTemplate`,
        defaultMessage: 'Select Week Template',
    },
    selectWeekTemplateExplanation: {
        id: `${scope}.label.selectWeekTemplateExplanation`,
        defaultMessage: 'Select a week template, or create a new one, to edit shifts, name and color.',
    },
    nameOfWeekTemplate: {
        id: `${scope}.label.nameOfWeekTemplate`,
        defaultMessage: 'Name of week template',
    },
    colorOfWeekTemplate: {
        id: `${scope}.label.colorOfWeekTemplate`,
        defaultMessage: 'Color',
    },
    weekTemplateCreatedSuccessfully: {
        id: `${scope}.label.weekTemplateCreatedSuccessfully`,
        defaultMessage: 'Week template created.',
    },
    weekTemplateSavedSuccessfully: {
        id: `${scope}.label.weekTemplateSavedSuccessfully`,
        defaultMessage: 'Week template saved.',
    },
    weekTemplateSaveFailed: {
        id: `${scope}.label.weekTemplateSaveFailed`,
        defaultMessage: 'Failed to save week template.',
    },
    weeklyShifts: {
        id: `${scope}.label.weeklyShifts`,
        defaultMessage: 'Weekly Shifts',
    },
    monday: {
        id: `${scope}.label.monday`,
        defaultMessage: 'Monday',
    },
    tuesday: {
        id: `${scope}.label.tuesday`,
        defaultMessage: 'Tuesday',
    },
    wednesday: {
        id: `${scope}.label.wednesday`,
        defaultMessage: 'Wednesday',
    },  
    thursday: {
        id: `${scope}.label.thursday`,
        defaultMessage: 'Thursday',
    },
    friday: {
        id: `${scope}.label.friday`,
        defaultMessage: 'Friday',
    },
    saturday: {
        id: `${scope}.label.saturday`,
        defaultMessage: 'Saturday',
    },
    sunday: {
        id: `${scope}.label.sunday`,
        defaultMessage: 'Sunday',
    },
    start: {
        id: `${scope}.label.start`,
        defaultMessage: 'Start',
    },
    end: {
        id: `${scope}.label.end`,
        defaultMessage: 'End',
    },  
    nameOfShift: {
        id: `${scope}.label.nameOfShift`,
        defaultMessage: 'Name of shift',
    },
    addShift: {
        id: `${scope}.label.addShift`,
        defaultMessage: 'Add Shift',
    },
    noShiftsDefined: {
        id: `${scope}.label.noShiftsDefined`,
        defaultMessage: 'No shifts defined',
    },
    selectWeekTemplateToEditShifts: {
        id: `${scope}.label.selectWeekTemplateToEditShifts`,
        defaultMessage: 'Select week template to edit shifts',
    },
    firstDateOfWeek: {
        id: `${scope}.label.firstDateOfWeek`,
        defaultMessage: 'First date of week',
    },
    endDate: {
        id: `${scope}.label.endDate`,
        defaultMessage: 'End date',
    },
    weekTemplateToAssign: {
        id: `${scope}.label.weekTemplateToAssign`,
        defaultMessage: 'Week template to assign',
    },
    machinesToAssign: {
        id: `${scope}.label.machinesToAssign`,
        defaultMessage: 'Machines to assign',
    },
    assignWeekTemplateToMachines: {
        id: `${scope}.label.assignWeekTemplateToMachines`,
        defaultMessage: 'Assign Week Template to Machines',
    },
    removeWeekTemplate: {
        id: `${scope}.label.removeWeekTemplate`,
        defaultMessage: '-- Remove Week Template --',
    },
    unassignWeekTemplateFromMachines: {
        id: `${scope}.label.unassignWeekTemplateFromMachines`,
        defaultMessage: 'Unassign Week Template from Machines',
    },
    plannedCalendar: {
        id: `${scope}.label.plannedCalendar`,
        defaultMessage: 'Planned Calendar',
    },
    fromDateMonday: {
        id: `${scope}.label.fromDateMonday`,
        defaultMessage: 'From Date (monday)',
    },
    fromDate: {
        id: `${scope}.label.fromDate`,
        defaultMessage: 'From Date',
    },
    toDate: {
        id: `${scope}.label.toDate`,
        defaultMessage: 'To Date',
    },
    machines: {
        id: `${scope}.label.machines`,
        defaultMessage: 'Machines (optional filter)',
    },
    allMachines: {
        id: `${scope}.label.allMachines`,
        defaultMessage: 'All Machines',
    },
    allMachinesSelected: {
        id: `${scope}.label.allMachinesSelected`,
        defaultMessage: 'All machines selected',
    },
    date: {
        id: `${scope}.label.date`,
        defaultMessage: 'Date',
    },
    plannedHours: {
        id: `${scope}.label.plannedHours`,
        defaultMessage: 'Planned Hours',
    },
    source: {
        id: `${scope}.label.source`,
        defaultMessage: 'Source',
    },
    assignedMachines: {
        id: `${scope}.label.assignedMachines`,
        defaultMessage: 'Assigned Machines',
    },
    showDetails: {
        id: `${scope}.label.showDetails`,
        defaultMessage: 'Show Details',
    },
    detailsForPlannedCalendar: {
        id: `${scope}.label.detailsForPlannedCalendar`,
        defaultMessage: 'Details for Planned Calendar',
    },
    close: {
        id: `${scope}.label.close`,
        defaultMessage: 'Close',
    },
    save: {
        id: `${scope}.label.save`,
        defaultMessage: 'Save',
    },
    saveWeekTemplate: {
        id: `${scope}.label.saveWeekTemplate`,
        defaultMessage: 'Save Week Template',
    }, 
    createWeekTemplate: {
        id: `${scope}.label.createWeekTemplate`,
        defaultMessage: 'Create Week Template',
    },
    errorCouldNotUpdateScheduleForDay: {
        id: `${scope}.label.errorCouldNotUpdateScheduleForDay`,
        defaultMessage: 'Error: Could not update schedule for the day.',
    },
    errorCouldNotRemoveTemplateAssignment: {
        id: `${scope}.label.errorCouldNotRemoveTemplateAssignment`,
        defaultMessage: 'Error: Could not remove template assignment.',
    },
    errorInvalidNumberOfHours: {
        id: `${scope}.label.errorInvalidNumberOfHours`,
        defaultMessage: 'Error: Invalid number of hours.',
    },
    errorNoTemplateOrHoursProvided: {
        id: `${scope}.label.errorNoTemplateOrHoursProvided`,
        defaultMessage: 'Error: No template or hours provided.',
    },
    noPlannedCalendarFound: {
        id: `${scope}.label.noPlannedCalendarFound`,
        defaultMessage: 'No planned calendar found for the selected period.',
    },
    noRowSelected: {
        id: `${scope}.label.noRowSelected`,
        defaultMessage: 'No row selected.',
    },
    name: {
        id: `${scope}.label.name`,
        defaultMessage: 'Name',
    },
    comment: {
        id: `${scope}.label.comment`,
        defaultMessage: 'Comment',
    },
    addExceptionDay: {
        id: `${scope}.label.addExceptionDay`,
        defaultMessage: 'Add Day',
    },
    excemptedDays: {
        id: `${scope}.label.excemptedDays`,
        defaultMessage: 'Exempted Days',
    },
    year: {
        id: `${scope}.label.year`,
        defaultMessage: 'Year',
    },
    manuallyOverridden: {
        id: `${scope}.label.manuallyOverridden`,
        defaultMessage: 'Manually overridden',
    },
    schema: {
        id: `${scope}.label.schema`,
        defaultMessage: 'Schema',
    },
    holiday: {
        id: `${scope}.label.holiday`,
        defaultMessage: 'Holiday',
    },
    dateMissing: {
        id: `${scope}.label.dateMissing`,
        defaultMessage: 'Date missing',
    },
    couldNotSaveExceptionDay: {
        id: `${scope}.label.couldNotSaveExceptionDay`,
        defaultMessage: 'Could not save exception day',
    },
    couldNotRemoveExceptionDay: {
        id: `${scope}.label.couldNotRemoveExceptionDay`,
        defaultMessage: 'Could not remove exception day',
    },
    importExceptionDays: {
        id: `${scope}.label.importExceptionDays`,
        defaultMessage: 'Import Holidays',
    },
    noExcemptedDaysFoundForYear: {
        id: `${scope}.label.noExcemptedDaysFoundForYear`,
        defaultMessage: 'No exempted days found for the selected year.',
    },
    updateDay: {
        id: `${scope}.label.updateDay`,
        defaultMessage: 'Update Day',
    },
    addDay: {
        id: `${scope}.label.addDay`,
        defaultMessage: 'Add Day',
    },
    legendTitle: {
        id: `${scope}.label.legendTitle`,
        defaultMessage: 'Explanation of colors and symbols',
    },
    holidayLegend: {
        id: `${scope}.label.holidayLegend`,
        defaultMessage: 'Holiday (diagonal pattern)',
    },
    manuallyOverriddenLegend: {
        id: `${scope}.label.manuallyOverriddenLegend`,
        defaultMessage: 'Manually overridden (yellow border)',
    },
    unplannedLegend: {
        id: `${scope}.label.unplannedLegend`,
        defaultMessage: 'Unplanned (empty)',
    },
});